import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class DocumentService {
  constructor(private http: HttpClient) {}

  public getDoc(docId: any): Observable<any> {
    const url = `${environment.serviceURL}/getDoc?id=${docId}`;
    return this.http.get<any>(url, { responseType: "json" });
  }

  public saveDoc(content: any): Observable<any> {
    const url = `${environment.serviceURL}/saveDoc`;
    return this.http.post<any>(url, content);
  }

  public updateDoc(content: any): Observable<any> {
    const url = `${environment.serviceURL}/updateDoc`;
    return this.http.put<any>(url, content);
  }
}
